import { render, staticRenderFns } from "./sortyBy.vue?vue&type=template&id=9d903910&scoped=true&"
import script from "./sortyBy.vue?vue&type=script&lang=js&"
export * from "./sortyBy.vue?vue&type=script&lang=js&"
import style0 from "./sortyBy.vue?vue&type=style&index=0&id=9d903910&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d903910",
  null
  
)

export default component.exports